export default {
  currentOrganization: {
    loading: false,
    error: null,
    details: JSON.parse(localStorage.CURRENT_ORGANIZATION || '{}'),
  },
};
